import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "createEditVenueModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "VenueModal_header"
}
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_8 = {
  class: "scroll-y me-n7 pe-7",
  id: "VenueModal_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#VenueModal_header",
  "data-kt-scroll-wrappers": "#VenueModal_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_9 = { class: "row mb-5" }
const _hoisted_10 = { class: "col-md-12 fv-row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Name", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-5" }
const _hoisted_15 = { class: "col-md-6 fv-row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Entrance", -1)
const _hoisted_17 = { class: "col-md-6 fv-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Address", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = { class: "col-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Country")
], -1)
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "City", -1)
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "row mb-5" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "ZIP code", -1)
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Province", -1)
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "mb-3 mt-3 col-12" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Notes", -1)
const _hoisted_42 = { class: "d-flex gap-5" }
const _hoisted_43 = {
  key: 0,
  class: "mb-3 mt-3 w-100"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  for: "clientsDropdown",
  class: "form-label"
}, "Client", -1)
const _hoisted_45 = { class: "mt-3 mb-3 w-100" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  for: "formFileMultiple",
  class: "form-label"
}, "Upload photos", -1)
const _hoisted_47 = {
  ref: "imageUpload",
  class: "form-control",
  type: "file",
  id: "formFileMultiple",
  multiple: ""
}
const _hoisted_48 = { class: "modal-footer flex-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "VenueModal_cancel",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}, " Discard ", -1)
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "mb-1 spinner-border spinner-border-sm align-middle"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Submit ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CountriesDropdown = _resolveComponent("CountriesDropdown")!
  const _component_ClientsDropdown = _resolveComponent("ClientsDropdown")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form",
          "validation-schema": _ctx.validationSchema,
          onSubmit: _ctx.handleSave,
          ref: "formComponent"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", null, _toDisplayString(_ctx.title), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "Enter name",
                      name: "name"
                    }),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "name" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "Enter entrance",
                      name: "entrance"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_Field, {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "Enter address",
                      name: "address"
                    }),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, { name: "address" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_CountriesDropdown, {
                      "initial-value": 
                      _ctx.currentlySelectedVenue
                        ? _ctx.currentlySelectedVenue.country.id
                        : ''
                    ,
                      ref: "countriesDropdown",
                      name: 'country'
                    }, null, 8, ["initial-value"]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_ErrorMessage, { name: "country" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "Enter city",
                      name: "city"
                    }),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(_component_ErrorMessage, { name: "city" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "Enter ZIP",
                      name: "zip"
                    }),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "zip" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_Field, {
                      class: "form-control form-control-solid",
                      placeholder: "Province",
                      name: "province"
                    }),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "province" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_Field, { name: "notes" }, {
                      default: _withCtx(({ field }) => [
                        _createElementVNode("textarea", _mergeProps(field, {
                          class: "form-control",
                          id: "exampleFormControlTextarea1",
                          rows: "3"
                        }), null, 16)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  (_ctx.canSelectClient)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_ClientsDropdown, {
                          modelValue: _ctx.client,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
                          name: "company_id",
                          id: "clientsDropdown"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("input", _hoisted_47, null, 512)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("button", {
                type: "submit",
                id: "VenueModal_submit",
                class: "btn btn-primary",
                disabled: _ctx.loading
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51))
                  : _createCommentVNode("", true),
                _hoisted_52
              ], 8, _hoisted_50)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "onSubmit"])
      ])
    ])
  ]))
}